import './SuccessCard.scss'
import SuccessIcon from './success_icon.svg'
import PropTypes from 'prop-types'

export const SuccessCard = ({ children, text, subtext }) => {
  return (
    <section className="c-success-card">
      <img
        alt="success icon"
        className="c-success-card__image"
        src={SuccessIcon}
      />
      <div>
        <p className="c-success-card__text">{text}</p>
        <p className="c-success-card__subtext">{subtext}</p>
      </div>
      <div className="children-container">{children}</div>
    </section>
  )
}

SuccessCard.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
}

export default SuccessCard
